import { render, staticRenderFns } from "./Leyes.vue?vue&type=template&id=2e65498b&scoped=true&"
import script from "./Leyes.vue?vue&type=script&lang=js&"
export * from "./Leyes.vue?vue&type=script&lang=js&"
import style0 from "./Leyes.vue?vue&type=style&index=0&id=2e65498b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65498b",
  null
  
)

export default component.exports